import { useState } from 'react';
import { DocLinkBlock } from '../../viz.types';
import { resolveDocLinks } from './docLinkBlock.utils';

export const useDocLinkBlock = (block: DocLinkBlock) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return {
    links: resolveDocLinks(block),
    isExpanded,
    toggle: () => setIsExpanded((current) => !current),
  };
};
